import React from 'react'

import { Collection, Group } from '../../components/details/collection'

import LocationCard from '../locations/location-card'
import { CollectionButton } from '../buttons'

export default ({
  locations,

  location: routerLocation,

  hasNextPage,
  onLoadNextPage,
  onSearchLocations
}) => (
  <div className='list'>
    <div className='form-group list-search collection-search'>
      <input type='search' onChange={(event) => {
        onSearchLocations(event.target.value)
        return event
      }} placeholder='Filter by Location...' className='form-control form-control-lg' />
    </div>
    <Collection constraints={{ width: '595px' }}>
      <Group title='Locations'>
        {locations.map(location => (
          <LocationCard location={location} key={location.id} linkUrlBase={routerLocation.pathname} />
        ))}
      </Group>
    </Collection>

    {hasNextPage &&
      <CollectionButton onClick={onLoadNextPage}>See more...</CollectionButton>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-trackers-list.js